export default __webpack_public_path__ + "static/media/Boots of Clawing Might.a2b9ab78.jpg";